// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"style_aboutContainer__thTNb","content":"style_content__oLdYn","spoilerShadow":"style_spoilerShadow__XBzGc","spoilerControl":"style_spoilerControl__qhZpF"};